export const GET_STRIPE_SESSION = `stripe/GET_STRIPE_SESSION`
export const UPDATE_STRIPE_SESSION = `stripe/UPDATE_STRIPE_SESSION`
